// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8610278a","178":"1b8db79f","233":"0232ac2e","714":"ad0f5cd8","722":"06f60855","854":"c670772d","953":"c2c6b57a"}[chunkId] + ".chunk.js";
};